import React, { useState, useEffect,useRef } from "react";
import { toast } from "react-toastify";
import Modal from "react-modal";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import html2pdf from "html2pdf.js";
import { useAuth } from "../../../store/auth";


const ReturnInvoiceList = (props) => {
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
     // border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    setSelectedData(data);
    //console.log(data);

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);

  const [docurl, setDocUrl] = useState(false);
  const [salesReturnInvoiceId, setSalesReturnInvoiceId] = useState([]);

 

  const { sendRequest: getSalesReturnInvoice } = useHttp();

  const getData = () => {
    getSalesReturnInvoice(
      {
        url: `/api/salesInvoiceReturn/?orgId=${localStorage.getItem("orgId")}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
          //console.log(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item.docNo.includes(filetrtext) ||
        item.name.includes(filetrtext) ||
        item.contactPersonName.includes(filetrtext)
    );
    //console.log(filterdata);

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const { sendRequest: deleteSalesReturnInvoice } = useHttp();

  const handleDelete = (e, salesReturnInvoiceId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Sales Invoice detail?",
      onOk() {
    const data = {
      salesReturnInvoiceId: salesReturnInvoiceId,
    };
    //console.log(data);

    deleteSalesReturnInvoice(
      {
        url: "/api/salesInvoiceReturn/",
        method: "DELETE",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(data);
        getData();
      },
      (error) => {
        //console.log(error);
        toast.error(error);
      }
    );
  },
  onCancel() {
    // Do nothing if the user cancels the delete action.
  },
});
  };

      
  const pdfContainerRef = useRef(null);
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);
  const{orgData}=useAuth();

  const viewPdf = (data) => {
    setPdfView(true);
    if(data){
      setPdfData(data);
    }
  };

  const printPdfContainer = () => {
    const elementsToHide = document.querySelectorAll(".no-print");
    elementsToHide.forEach((element) => {
      element.style.display = "none !important";
    });
    document.body.style.overflow = "visible";

    window.print();
    document.body.style.overflow = "";
    elementsToHide.forEach((element) => {
      element.style.display = "";
    });
  };

  const generatePDF = (docNo) => {
    const input = pdfContainerRef.current;

    const pdfName = docNo || "Sales Return Invoice";

    html2pdf(input, {
      margin: 10,
      filename: `${pdfName}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { mode: "avoid-all" },
    });
  };
  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Sales Return Invoice</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Sales Return Invoice
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-sm table-bordered text-center">
                      <thead>
                        <tr className="">
                          <th>Order Date</th>
                          <th>Doc No</th>
                          <th>Sales order No</th>
                          <th>Delivery Date</th>
                          <th>DnD No</th>
                          <th>Sales Invoice No</th>
                          <th>Sales Return No</th>
                          <th>Customer Name</th>
                          <th>Contact Person Name</th>
                          <th>Total Return cost/Value</th>

                          <th>View</th>
                          <th>Delete</th>
                         
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems &&
                          currentItems.map((x) => {
                            return (
                              <tr key={x.salesOrderId}>
                                <td>{x.date}</td>
                                <td>{x.docNo}</td>
                                <td>{x.salesOrderCode}</td>
                                <td>{x.estimatedDeliveryDate}</td>
                                <td>{x.dndNo}</td>
                                <td>{x.salesInvoiceCode}</td>
                                <td>{x.salesReturnNCode}</td>
                                <td>{x.name}</td>
                                <td>{x.customerContactPersonName}</td>
                                <td>{x.totalReturnCostValue}</td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() =>
                                      viewPdf(x)
                                    }
                                  >
                                   <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={(e) =>
                                      handleDelete(e, x.salesReturnInvoiceId)
                                    }
                                    className="btn"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                                {/* <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(x)}
                                  ><i className="fas fa-eye"></i>
                                    
                                  </button>
                                </td> */}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-3">
              <h4 className="card-title">Sales Return Invoice Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          
            <div className="row">
              <p className="col-md-6">
                Sales Return Invoice No: {selectedData.docNo}
              </p>
              <p className="col-md-6">
                Return Invoice Date : {selectedData.date}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Sales Return No: {selectedData.salesReturnNo}
              </p>

              <p className="col-md-6">
                Sales Invoice No: {selectedData.salesInvoiceNo}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Sales Order No: {selectedData.salesOrderCode}
              </p>

              <p className="col-md-6">
                Delievry Dispatch No: {selectedData.dndNo}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Customer Name: {selectedData.name}
              </p>

              <p className="col-md-6">
                Contact Person Name : {selectedData.customerContactPersonName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Condition Of Item: {selectedData.conditionOfItem}.
              </p>
              <p className="col-md-6">
                Reason Of Item: {selectedData.reasonOfItem}.
              </p>
            </div>

            <h5 className="card-title">Product Details</h5>
            <table className="table table-bordered table-responsive table-sm">
              <thead>
                <tr>
                  <th>Sr. No</th>

                  <th>Item Category</th>
                  <th>Item Description</th>
                  <th>Item Unit Price</th>
                  <th>Rate</th>
                  <th>Return Quantity</th>
                  <th>Unit</th>
                  <th>Amount</th>
                  <th>Discount</th>
                  <th>Discount Amount</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.salesInvoiceReturnProducts &&
                  selectedData.salesInvoiceReturnProducts.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>

                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemUnitPrice}</td>
                        <td>{itm.rate}</td>
                        <td>{itm.salesReturnInvoiceQuantity}</td>
                        <td>{itm.unitAbbreviation}</td>
                        <td>{itm.subTotalAmount}</td>
                        <td>{itm.discount}</td>
                        <td>{itm.discountAmount}</td>
                        <td>{itm.totalLineAmount}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div className="row">
              <p className="col-md-4">
                Total Amount: {selectedData.totalAmount}
              </p>
              <p className="col-md-4">Tax : {selectedData.taxName}</p>
              <p className="col-md-4">Tax Amount: {selectedData.taxAmount}</p>
            </div>
            <div className="row">
              <p className="col-md-4">
                Invoice Return Cost Value : {selectedData.totalReturnCostValue}
              </p>
              <p className="col-md-4">Currency: {selectedData.currencyName}</p>
              <p className="col-md-4">
                Amount Chargeable: {selectedData.amountChargeable}
              </p>
            </div>
          </div>
        )}
      </Modal>

      {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          <div className="pdf-main-container ">
            <div className="row no-print">
              <div className="col-md-11"></div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setPdfView(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>

            <div className="pdf-container mx-3 my-4" ref={pdfContainerRef}>
              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      {/* Main content */}
                      <div className="invoice p-3 mb-3">
                        {/* title row */}
                        <div className="row">
                          <div className="col-12">
                            <h4>
                              <img
                                src={`${process.env.REACT_APP_FILE_URL}${
                                  orgData && orgData.organizationIcon
                                }`}
                                width="50"
                                height="50"
                                alt=""
                              />
                              &nbsp;Sales Return Invoice
                            </h4>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* info row */}
                        <div className="row invoice-info">
                          <div className="col-sm-4 invoice-col">
                            From
                            <address>
                              <strong>{orgData && orgData.orgName}</strong>
                              <br />
                              {orgData && orgData.city}{" "}
                              {orgData && orgData.state}
                              <br />
                              {orgData && orgData.country}{" "}
                              {orgData && orgData.zipCode}
                              <br />
                              Phone: {orgData && orgData.phoneNumber}
                              <br />
                              Email: {orgData && orgData.orgEmail}
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            To
                            <address>
                              <strong>{pdfData && pdfData.name}</strong>
                              <br />
                              Customer Code: {pdfData && pdfData.customerCode}
                         
                              <br />
                         
                              Phone: {pdfData && pdfData.workContactNumber}
                              <br />
                              Email: {pdfData && pdfData.customerEmailId}
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            <br />
                            <b>Date:</b> {pdfData && pdfData.date}
                            <br />
                            <b>Invoice No:</b> {pdfData && pdfData.docNo}
                            <br />
                            <b>Return No:</b> {pdfData && pdfData.salesReturnNCode}
                            <br />
                            <b>Currency:</b> {pdfData && pdfData.currencyName}
                            <br />
                            <b>Expected Delivery:</b>
                            {pdfData && pdfData.deliveryDate}
                            <br />
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        {/* Table row */}
                        <div className="row">
                          <div className="col-12 table-responsive">
                            <table className="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th>Sr.No</th>
                                  {/* <th>Item Type</th> */}
                                  <th>Item Description</th>
                                  <th>Item Unit Price</th>
                                  <th>Rate</th>
                                  <th>Quantity</th>
                             
                                  <th>Amount</th>
                                  <th>Discount</th>
                                 
                                  <th>Sub Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pdfData.salesInvoiceReturnProducts &&
                                  pdfData.salesInvoiceReturnProducts.map((itm, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>{i + 1}</td>

                                        {/* <td>{itm.productSubTypeName}</td> */}
                                        <td>{itm.productName}</td>
                                        <td>{itm.itemUnitPrice}</td>
                                        <td>{itm.rate}</td>
                                        <td>{itm.salesReturnInvoiceQuantity+" "+itm.unitAbbreviation}</td>
                                      
                                        <td>{itm.subTotalAmount}</td>
                                        <td>{itm.discountAmount } ({itm.discount}%)</td>
                                        
                                        <td>{itm.totalLineAmount}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        <div className="row">
                          <div className="col-6">
                            <p className="text-muted well well-sm shadow-none">
                              Remark/Note:
                            </p>
                            <p> {pdfData && pdfData.remark}</p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              Name of Authorized Signatory:
                            </p>
                            <hr />
                          
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              This is Computer Generated Document
                            </p>
                          </div>

                          <div className="col-6">
                            <div className="table-responsive">
                              <table className="table">
                                <tbody className="text-right">
                              
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Total Amount:
                                    </th>
                                    <td> {pdfData && pdfData.totalAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>
                                      Tax Amount (
                                      {pdfData && pdfData.taxPercentage}%)
                                    </th>
                                    <td> {pdfData && pdfData.taxAmount}</td>
                                  </tr>
                               
                                  <tr>
                                    <th>Total Cost:</th>
                                    <td> {pdfData && pdfData.totalReturnCostValue}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="row no-print">
            <div className="col-12">
              {/* <a
                href=""
                rel="noopener"
                target="_blank"
                className="btn btn-default print-button"
                onClick={() => printPdfContainer()}
              >
                <i className="fas fa-print" /> Print
              </a> */}

              <button
                type="button"
                className="btn btn-primary float-right generate-pdf-button"
                style={{ marginRight: 5 }}
                onClick={() => generatePDF(pdfData && pdfData.docNo)}
              >
                <i className="fas fa-download" /> Generate PDF
              </button>
            </div>
          </div>
        </Modal>
      )}
   
    </>
  );
};

export default ReturnInvoiceList;
